import { documentDetails, MasterDataState, StaffType, User } from '@/types/MasterData';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: MasterDataState = {
  users: [],
  staffTypes: [],
  organizationTypes: [],
  cities: [],
  documentDetails: null,
};

export const masterDataSlice = createSlice({
  name: 'masterData',
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<User[]>) => {
      state.users = action.payload;
    },
    setStaffTypes: (state, action: PayloadAction<StaffType[]>) => {
      state.staffTypes = action.payload;
    },
    setOrganizationTypes: (state, action) => {
      state.organizationTypes = action.payload;
    },
    setCities: (state, action) => {
      state.cities = action.payload;
    },
    setDocumentDetails(state, action: PayloadAction<documentDetails>) {
      state.documentDetails = action.payload;
    },
  },
});

export const { setUsers, setStaffTypes, setOrganizationTypes, setCities, setDocumentDetails } = masterDataSlice.actions;

export default masterDataSlice.reducer;
